"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var DevelopmentsAction;
(function (DevelopmentsAction) {
    DevelopmentsAction.ON_DEV_CONTACT_FORM_CLICKED = 'ON_DEV_CONTACT_FORM_CLICKED';
    DevelopmentsAction.RELOAD_PROJECTS = 'RELOAD_PROJECTS';
    DevelopmentsAction.CHANGE_PAGE = 'CHANGE_PAGE';
    DevelopmentsAction.onDevContactFormClicked = typesafe_actions_1.createAction(DevelopmentsAction.ON_DEV_CONTACT_FORM_CLICKED, function (resolve) { return function () { return resolve(); }; });
    DevelopmentsAction.reloadProjects = typesafe_actions_1.createAction(DevelopmentsAction.RELOAD_PROJECTS, function (resolve) { return function (projects) { return resolve(projects); }; });
    DevelopmentsAction.changePage = typesafe_actions_1.createAction(DevelopmentsAction.CHANGE_PAGE, function (resolve) { return function (page) { return resolve(page); }; });
})(DevelopmentsAction || (DevelopmentsAction = {}));
exports.default = DevelopmentsAction;
